import { useEquipmentStore } from "@/frontend/store/EquipmentStore";
import { BasicButton } from "../buttons/BasicButton";
import { useState } from "react";
import { I18n } from "@/i18n/I18n";
import { EquipmentItemModal } from "./EquipmentItemModal";

export function CreateEquipmentButton() {
  const [show, setShow] = useState(false);
  const createEquipment = useEquipmentStore(state => state.createEquipment);

  return (
    <>
      <BasicButton className='btn btn-secondary' onClick={() => setShow(true)} label={I18n.get('addEquipment')} />
      { show && <EquipmentItemModal onConfirm={createEquipment} setShow={setShow} /> }
    </>
  );
}
